import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import "./SearchCityInput.scss";
import { useGetCitiesListQuery } from "../../../../rtk-query/features/cohort/cohortRTK";
import { useDispatch, useSelector } from "react-redux";
import {
  setClearAll,
  setSelectedCities,
} from "../../../../rtk-query/features/cohort/cohortSlice";
import { Skeleton } from "primereact/skeleton";
import Chip from "./Chip";
import useFetch from "../../../../rtk-query/features/useFetch";

// const initialCities = [
//   { value: "south_dakota", label: "South Dakota" },
//   { value: "north_carolina", label: "North Carolina" },
//   { value: "alabama", label: "Alabama" },
//   { value: "alaska", label: "Alaska" },
//   { value: "west_virginia", label: "West Virginia" },
//   { value: "wisconsin", label: "Wisconsin" },
//   { value: "arizona", label: "Arizona" },
//   { value: "arkansas", label: "Arkansas" },
//   { value: "california", label: "California" },
//   { value: "colorado", label: "Colorado" },
//   { value: "connecticut", label: "Connecticut" },
//   { value: "delaware", label: "Delaware" },
//   { value: "florida", label: "Florida" },
//   { value: "mississippi", label: "Mississippi" },
//   { value: "georgia", label: "Georgia" },
//   { value: "hawaii", label: "Hawaii" },
//   { value: "idaho", label: "Idaho" },
//   { value: "illinois", label: "Illinois" },
//   { value: "indiana", label: "Indiana" },
//   { value: "iowa", label: "Iowa" },
//   { value: "kansas", label: "Kansas" },
//   { value: "pennsylvania", label: "Pennsylvania" },
//   { value: "rhode_island", label: "Rhode Island" },
//   { value: "south_carolina", label: "South Carolina" },
//   { value: "kentucky", label: "Kentucky" },
//   { value: "louisiana", label: "Louisiana" },
//   { value: "maine", label: "Maine" },
//   { value: "maryland", label: "Maryland" },
//   { value: "massachusetts", label: "Massachusetts" },
//   { value: "michigan", label: "Michigan" },
//   { value: "minnesota", label: "Minnesota" },
//   { value: "missouri", label: "Missouri" },
//   { value: "montana", label: "Montana" },
//   { value: "nebraska", label: "Nebraska" },
//   { value: "nevada", label: "Nevada" },
//   { value: "new_hampshire", label: "New Hampshire" },
//   { value: "new_jersey", label: "New Jersey" },
//   { value: "new_mexico", label: "New Mexico" },
//   { value: "new_york", label: "New York" },
//   { value: "north_dakota", label: "North Dakota" },
//   { value: "ohio", label: "Ohio" },
//   { value: "oklahoma", label: "Oklahoma" },
//   { value: "oregon", label: "Oregon" },
//   { value: "tennessee", label: "Tennessee" },
//   { value: "texas", label: "Texas" },
//   { value: "utah", label: "Utah" },
//   { value: "vermont", label: "Vermont" },
//   { value: "virginia", label: "Virginia" },
//   { value: "washington", label: "Washington" },
//   { value: "wyoming", label: "Wyoming" },
// ];

const sortCities = (cities) => {
  if (!cities) return [];
  return [...cities].sort((a, b) => a.state.localeCompare(b.state));
};

const searchCities = (cities, searchText) => {
  if (!searchText) return cities;
  const text = searchText.toLowerCase();
  return cities?.filter(
    (item) =>
      item?.state?.toLowerCase()?.includes(text) ||
      item?.abbreviation?.toLowerCase()?.includes(text),
  );
};

const SearchCityInput = () => {
  const dispatch = useDispatch();
  const [showOptions, setShowOptions] = useState(false);
  const [filteredCities, setFilteredCities] = useState([]);
  const [showCities, setShowCities] = useState([]);
  const [searchText, setSearchText] = useState("");

  const selectedCohort = useSelector(
    (state) => state?.cohortReducer?.selectedCohort,
  );

  const clearAll = useSelector((state) => state?.cohortReducer?.clearAll);

  const selectedCities = useSelector(
    (state) => state?.cohortReducer?.selectedCities,
  );

  const {
    data: initialCities,
    isError: isErrorInitialCities,
    isLoading: isLoadingInitialCities,
  } = useFetch(useGetCitiesListQuery, {});

  useEffect(() => {
    if (initialCities?.data?.length) {
      const excludeCities = new Set(selectedCities?.map((item) => item.state));
      const cities = sortCities(
        initialCities?.data?.filter((item) => !excludeCities?.has(item.state)),
      );
      setFilteredCities(cities);
      if (clearAll) {
        setSearchText("");
        setTimeout(() => {
          dispatch(setClearAll(false));
        }, 1000);
      }
    }
  }, [initialCities?.data, clearAll]);

  useEffect(() => {
    if (
      initialCities?.data?.length &&
      selectedCohort?.filter_Json?.state?.length
    ) {
      dispatch(
        setSelectedCities(
          initialCities?.data?.filter((i) =>
            selectedCohort?.filter_Json?.state?.includes(i?.abbreviation),
          ),
        ),
      );
      setFilteredCities(
        sortCities(
          initialCities?.data?.filter(
            (i) =>
              !selectedCohort?.filter_Json?.state?.includes(i?.abbreviation),
          ),
        ),
      );
    } else {
      dispatch(setSelectedCities([]));
    }
  }, [initialCities?.data, selectedCohort?.filter_Json?.state]);

  useEffect(() => {
    setShowCities(searchCities(filteredCities, searchText));
  }, [filteredCities, searchText]);

  const addSelectedCity = (e, city) => {
    if (e.button === 0) {
      dispatch(setSelectedCities([...selectedCities, city]));
      setFilteredCities(
        filteredCities?.filter((i) => i?.abbreviation !== city?.abbreviation),
      );
      setShowOptions(false);
    }
  };

  const removeSelectedCity = (e, city) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(
      setSelectedCities(
        selectedCities?.filter((i) => i?.abbreviation !== city?.abbreviation),
      ),
    );
    setFilteredCities(sortCities([...filteredCities, { ...city }]));
  };

  return (
    <div className="search-city-input-wrapper">
      {!isLoadingInitialCities && !clearAll ? (
        <div className="select-field">
          <FiSearch className="search-icon" />
          <input
            className="search-input"
            placeholder="Search states"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onFocus={() => setShowOptions(true)}
            onBlur={() => setShowOptions(false)}
            disabled={selectedCohort != null}
          />
        </div>
      ) : (
        <Skeleton height="3rem" />
      )}

      {showOptions && (
        <div className="option-pannel">
          <ul>
            {showCities?.length > 0 ? (
              showCities?.map((i) => (
                <li
                  key={i.abbreviation}
                  onMouseDown={(e) => addSelectedCity(e, i)}
                >
                  <span>{i?.state}</span>
                  <span>{i?.count}</span>
                </li>
              ))
            ) : (
              <li>No state found with search criteria!</li>
            )}
          </ul>
        </div>
      )}

      <div className="chip-container">
        {selectedCities?.length > 0 ? (
          <div className="chip-row">
            {selectedCities?.map((city) => (
              <Chip
                city={city}
                removeSelectedCity={removeSelectedCity}
                disabled={selectedCohort != null}
              />
            ))}
          </div>
        ) : (
          <div className="group">
            <div className="group-id">No states selected!</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchCityInput;
